export const VERSION_APP = "0.15.4.alpha"
export const VERSION_API = 4 // refers to redux-persist version
export const VERSION_SCORE = "1.0.0.beta" // refers to redux-persist version
